var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import '@gouvfr/dsfr/dist/component/button/button.min.css';
import { BoutonDefaultProps } from "./Bouton.types";
import LoaderMi from "../../../specifique/Loader/LoaderMi/LoaderMi";
var Bouton = function (_a) {
    var label = _a.label, niveau = _a.niveau, disabled = _a.disabled, icone = _a.icone, iconePosition = _a.iconePosition, taille = _a.taille, type = _a.type, isLoading = _a.isLoading, className = _a.className, otherProps = __rest(_a, ["label", "niveau", "disabled", "icone", "iconePosition", "taille", "type", "isLoading", "className"]);
    var boutonClassName = "fr-btn";
    if (isLoading) {
        boutonClassName += " dsmi-btn--loader";
    }
    if (niveau === "secondaire") {
        boutonClassName += " fr-btn--secondary";
    }
    else if (niveau === "tertiaire") {
        boutonClassName += " fr-btn--tertiary";
    }
    else if (niveau === "tertiaire-sans-bordure") {
        boutonClassName += " fr-btn--tertiary-no-outline";
    }
    if (icone) {
        boutonClassName += " ".concat(icone);
        if (iconePosition) {
            boutonClassName += " fr-btn--icon-".concat(iconePosition);
        }
    }
    if (taille && taille !== "md") {
        boutonClassName += " fr-btn--".concat(taille);
    }
    if (className) {
        boutonClassName += " ".concat(className);
    }
    var iconeSeule = icone && !iconePosition;
    return (React.createElement("button", __assign({ className: boutonClassName, disabled: disabled || isLoading, title: iconeSeule ? label : undefined, type: type }, otherProps),
        isLoading && React.createElement(LoaderMi, null),
        !(iconeSeule) && label));
};
Bouton.defaultProps = BoutonDefaultProps;
export default Bouton;
